import { CopyToClipboard } from "react-copy-to-clipboard";
import React, { useEffect } from "react";
import { useState } from "react";
import { toast } from "react-toastify";
import { getUserInfo, validateInviteCode } from "../../../services/profile";
import { getSystemContents } from "../../../services/statistics";
import { getSystemParameters } from "../../../services/cms";
import { useSearchParams } from "react-router-dom";

export default function Referal() {
  const [searchParams, setSearchParams] = useSearchParams();
  const refCode = searchParams.get("refCode");
  const [refUrl, setRefUrl] = useState("");
  const [contents, setContents] = useState([]);
  const [systemParams, setSystemParams] = useState([]);
  const [isCopied, setIsCopied] = useState(false);
  const [invitation, setInvitation] = useState(refCode);

  const handleInvitation = () => {
    validateInviteCode(invitation)
      .then((data) => {
        if (data.status === 200) {
          toast.success("کد دعوت ثبت شد");
        }
      })
      .catch((error) => {});
  };
  const onCopyText = () => {
    setIsCopied(true);
    toast.dismiss();
    toast.success(" کپی شد!", {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  useEffect(() => {
    function fetchData() {
      getUserInfo().then((res) => {
        if (res.status == 200) {
          let data = res?.data?.data;
          if (data) {
            setRefUrl(data.invitation_code);
          }
        }
        getSystemContents().then((res) => {
          const data = res.data?.results;
          if (data) {
            setContents(data);
          }
        });
        getSystemParameters().then((res) => {
          const data = res.data?.results;
          if (data) {
            setSystemParams(data);
          }
        });
      });
    }
    fetchData();
  }, []);
  useEffect(() => {
    if (refCode && refCode.length > 0) {
      handleInvitation();
    }
  }, []);
  return (
    <div className="invitation-desktop-wrapper">
      <div className="invite-code-entrance">
        <label>ثبت کد دعوت</label>
        <input
          name="invite-code-entry"
          value={invitation}
          onChange={(e) => setInvitation(e.target.value)}
        />
        <button onClick={handleInvitation}>ثبت کد</button>
      </div>
      <div className="content-for-invite-desktop">
        {systemParams.map((item) => {
          if (item.key === "invitation_gift_amount") return <>{item.message}</>;
        })}
      </div>

      <div className="kdsfjslink">
        <span className="ref-url-item-desktop">{refUrl}</span>

        <CopyToClipboard text={refUrl} onCopy={onCopyText}>
          <span className={"text-medium"}>
            <img className="copyicon" src="./images/svg/copy.svg" />
          </span>
        </CopyToClipboard>
      </div>
      <CopyToClipboard
        text={refUrl}
        onCopy={() => {
          onCopyText();
        }}
      >
        <button className="form-input-button-custom darker-yellow-color">
          دعوت از دوستان
        </button>
      </CopyToClipboard>
    </div>
  );
}
